{
  "id": "campaign-106",
  "name": "Fine Avenue",
  "seed": "campaign:106",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ".....UCCCCU.....",
    ".....UCCCCU.....",
    "..q....CC....q..",
    ".,,,...CC....x..",
    "..,...TCCT.x~...",
    ".T.T..CCCC.~T~T.",
    "....,tCwwCt.~...",
    ".Bq..,CwwC...qB.",
    "....t.CwwC.t....",
    "......CCCC......",
    "......hCCh......",
    "..Y....CC....Y..",
    "......tCCt......",
    "......,CC.......",
    ".......,x.......",
    ".....X....X....S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 12,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 13,
      "y": 4
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 12,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 13,
      "y": 1
    },
    {
      "kind": "repair",
      "x": 3,
      "y": 13
    }
  ],
  "falls": [
    {
      "x": 10,
      "y": 15,
      "dir": "W",
      "at": 14,
      "length": 3
    },
    {
      "x": 5,
      "y": 15,
      "dir": "E",
      "at": 20,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 106,
  "biome": "estate",
  "par": {
    "reel": 7189,
    "push": 6192,
    "selfPropelled": 5772,
    "tractor": 4710,
    "zeroTurn": 4062,
    "fairway": 2517
  },
  "goldTime": {
    "reel": 7189,
    "push": 6101,
    "selfPropelled": 5616,
    "tractor": 4590,
    "zeroTurn": 4062,
    "fairway": 2506
  },
  "routeTries": {
    "par": {
      "reel": 20,
      "push": 24,
      "selfPropelled": 12,
      "tractor": 7,
      "zeroTurn": 19,
      "fairway": 19
    },
    "gold": {
      "reel": 20,
      "push": 36,
      "selfPropelled": 32,
      "tractor": 39,
      "zeroTurn": 19,
      "fairway": 40
    }
  }
}
